/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

import styles from './components/cards.scss'

export const CLAN_LANDING_ROLE_DESCRIPTION = (
    <FormattedMessage
        id='clan_landing.role'
        defaultMessage='Ваша должность в клане:'
    />
)

export const CHALLENGES_OFF = (
    <FormattedMessage
        id='clan_landing.challenge.off'
        defaultMessage='Военные игры отключены'
    />
)

export const CHALLENGES_TIMER = (timer) => (
    <FormattedMessage
        id='clan_landing.challenges_timer'
        defaultMessage='осталось {timer}'
        values={{ timer }}
    />
)

export const CHALLENGES = (
    <FormattedMessage
        id='clan_landing.challenges'
        defaultMessage='Военные игры:'
    />
)

export const GLOBAL_MAP = (
    <FormattedMessage
        id='clan_landing.global_map'
        defaultMessage='Глобальная карта'
    />
)

export const GLOBAL_MAP_DISABLED = (
    <FormattedMessage
        id='clan_landing.global_map_disabled'
        defaultMessage='Бои на Глобальной карте временно приостановлены.'
    />
)

export const EVENT_ON_GLOBAL_MAP = (
    <FormattedMessage
        id='clan_landing.event_on_global_map'
        defaultMessage='Событие на Глобальной карте'
    />
)

export const ENTRYPOINT_CLAN = (
    <FormattedMessage
        id='stronghold.entrypoint.clan'
        defaultMessage='Перейти к профилю вашего клана'
    />
)

export const ENTRYPOINT_SEARCH = (
    <FormattedMessage
        id='stronghold.entrypoint.search'
        defaultMessage='Перейти к поиску клана'
    />
)

export const CLAN_TREASURY = (
    <FormattedMessage
        id='stronghold.entrypoint.clan_treasury'
        defaultMessage='Казна клана'
    />
)

export const PERSONAL_FAME_POINTS = (
    <FormattedMessage
        id='clan_landing.personal_fame_points'
        defaultMessage='Личные очки славы'
    />
)

export const PERSONAL_FAME_POINTS_BALANCE = pfp => (
    <FormattedMessage
        id='clan_landing.personal_fame_points_balance'
        defaultMessage='Сейчас: {pfp}'
        values={{ pfp }}
    />
)

export const PERSONAL_FAME_POINTS_EARN = (
    <FormattedMessage
        id='clan_landing.personal_fame_points_earn'
        defaultMessage='Заработать личные очки славы можно на Глобальной карте.'
    />
)

export const CLAN_QUESTS_PERSONAL_TITLE = (
    <FormattedMessage
        id='clan_landing.clan_quests.personal_title'
        defaultMessage='Поручения'
    />
)

export const CLAN_QUESTS_CLAN_TITLE = (
    <FormattedMessage
        id='clan_landing.clan_quests.clan_title'
        defaultMessage='Цели похода'
    />
)

export const CLAN_QUESTS_NEXT_ACCOUNT_REWARD_TITLE = (
    <FormattedMessage
        id='clan_landing.clan_quests.next_account_reward_title'
        defaultMessage='До получения награды:'
    />
)

export const CLAN_QUESTS_NEXT_CLAN_REWARD_TITLE = (
    <FormattedMessage
        id='clan_landing.clan_quests.next_clan_reward_title'
        defaultMessage='До получения трофея:'
    />
)

export const CLAN_QUESTS_ALL_PERSONAL_REWARDS_RECEIVED = (
    <FormattedMessage
        id="clan_landing.clan_quests.all_personal_rewards_received"
        defaultMessage="Все награды получены"
    />
)

export const CLAN_QUESTS_ALL_CLAN_REWARDS_RECEIVED = (
    <FormattedMessage
        id="clan_landing.clan_quests.all_clan_rewards_received"
        defaultMessage="Все трофеи получены"
    />
)

export const CLAN_QUESTS_PERSONAL_TIMER_TOOLTIP = (
    <FormattedMessage
        id="clan_landing.clan_quests.personal_timer_tooltip"
        defaultMessage="Время до обновления поручений."
    />
)

export const CLAN_QUESTS_PERSONAL_POINTS_TOOLTIP_TITLE = (
    <FormattedMessage
        id="clan_landing.clan_quests.personal_points_tooltip_title"
        defaultMessage="Очки личного вклада"
    />
)

export const CLAN_QUESTS_PERSONAL_POINTS_TOOLTIP_MESSAGE = (
    <FormattedMessage
        id="clan_landing.clan_quests.personal_points_tooltip_message"
        defaultMessage="Очки личного вклада можно заработать за выполнение поручений."
    />
)

export const CLAN_QUESTS_CLAN_POINTS_TOOLTIP_TITLE = (
    <FormattedMessage
        id="clan_landing.clan_quests.clan_points_tooltip_title"
        defaultMessage="Очки похода"
    />
)

export const CLAN_QUESTS_CLAN_POINTS_TOOLTIP_MESSAGE = (
    <FormattedMessage
        id="clan_landing.clan_quests.clan_points_tooltip_message"
        defaultMessage="Очки похода зарабатывают все игроки клана за достижение целей похода и выполнение поручений."
    />
)

export const CLAN_QUESTS_CLAN_TIMER_TOOLTIP = (
    <FormattedMessage
        id="clan_landing.clan_quests.clan_timer_tooltip"
        defaultMessage="Время до обновления целей похода."
    />
)

export const CLAN_QUESTS_CLAN_FINISHED_TITLE = (
    <FormattedMessage
        id='clan_landing.clan_quests.clan_finished_title'
        defaultMessage='Все цели похода достигнуты!'
    />
)

export const CLAN_QUESTS_ALL_FINISHED_TITLE = (
    <FormattedMessage
        id='clan_landing.clan_quests.all_finished_title'
        defaultMessage='Боевой поход успешно завершён!'
    />
)

export const CLAN_QUESTS_CLAN_TIMER_TITLE = (
    <FormattedMessage
        id='clan_landing.clan_quests.clan_timer_title'
        defaultMessage='До нового Боевого похода:'
    />
)

export const CLAN_QUESTS_RELOAD_BUTTON_TOOLTIP = (
    <FormattedMessage
        id='clan_landing.clan_quests.reload_button_tooltip'
        defaultMessage='Нажмите, чтобы обновить информацию о Боевых походах.'
    />
)

export const CLAN_QUESTS_DISABLED_TITLE = (
    <FormattedMessage
        id='clan_landing.clan_quests.disabled_title'
        defaultMessage='Боевой поход'
    />
)

export const CLAN_QUESTS_DISABLED_MESSAGE = (
    <FormattedMessage
        id='clan_landing.clan_quests.disabled_message'
        defaultMessage='Боевые походы временно приостановленны.'
    />
)

export const CLAN_QUESTS_NOT_AVAILABLE_MESSAGE = (
    <FormattedMessage
        id='clan_landing.clan_quests.not_available_message'
        defaultMessage='Информация о боевых походах временно недоступна.'
    />
)

export const CLAN_QUESTS_RELOAD_BUTTON_TITLE = (
    <FormattedMessage
        id='clan_landing.clan_quests.reload_button_title'
        defaultMessage='Обновить'
    />
)

export const CLAN_QUESTS_TUTORIAL_ARROW_TEXT = (
    <FormattedMessage
        id='clan_landing.clan_quests.tutorial_arrow_text'
        defaultMessage='ПЕРЕЙТИ{brTag}К ПОХОДУ'
        values={{
            brTag: <br/>,
        }}
    />
)

export const GLOBAL_MAP_NEAREST_BATTLE_TIME = (
    <FormattedMessage
        id='clan_landing.global_map.nearest_battle_time'
        defaultMessage='Время ближайшего боя на Глобальной карте'
    />
)

export const BATTLES_NOW = (
    <FormattedMessage
        id='clan_landing.battles_now'
        defaultMessage='Идут бои'
    />
)

export const TOMMOROW_IN = (
    <FormattedMessage
        id='clan_landing.tommorow_in'
        defaultMessage='Завтра в'
    />
)

export const PLUS = (isPlanned) => (
    isPlanned ?
    <FormattedMessage
        id='clan_landing.plus'
        defaultMessage='+'
    /> : null
)

export const TOMMOROW_TIME = (date, isPlanned) => (
        <FormattedMessage
            id='clan_landing.tomorrow_date'
            defaultMessage='{text}{space}{time}{plus}'
            values={{
                text: <span className={styles.battleText}>{TOMMOROW_IN}</span>,
                time: date.format('LT'),
                plus: PLUS(isPlanned),
                space: '\u2007',
            }}
        />
)

export const CUSTOM_DATE_TIME = (date, isPlanned) => (
        <FormattedMessage
            id='clan_landing.custom_date'
            defaultMessage='{time}{plus}{space}{date}'
            values={{
                date: <span className={styles.battleText}>{date.format('L')}</span>,
                time: date.format('LT'),
                plus: PLUS(isPlanned),
                space: '\u2007',
            }}
        />
)

export const TODAY_TIME = (date, isPlanned) => (
    <FormattedMessage
        id='clan_landing.today_date'
        defaultMessage='{time}{plus}'
        values={{
            time: date.format('LT'),
            plus: PLUS(isPlanned),
        }}
    />
)

export const STRONGHOLD_UPDATED = (
    <FormattedMessage
        id='clan_landing.stronghold_updated'
        defaultMessage='Обновление Укрепрайона'
    />
)

export const MANEUVERS_TITLE = (
    <FormattedMessage
        id='clan_landing.maneuvers_title'
        defaultMessage='Манёвры'
    />
)

export const MANEUVERS_DESCRIPTION = (
    <FormattedMessage
        id='clan_landing.maneuvers_description'
        defaultMessage='Клановые сражения за лидерство и ценные награды'
    />
)

export const CLAN_SUPPLY_QUESTS_TITLE = (
    <FormattedMessage
        id='clan_landing.clan_supply_quests_title'
        defaultMessage='Задачи похода'
    />
)
export const CLAN_SUPPLY_QUESTS_DISABLED_TEXT = (
    <FormattedMessage
        id='clan_landing.clan_supply_quests_disabled_text'
        defaultMessage='Выполнение задач похода приостановлено'
    />
)

export const CLAN_SUPPLY_QUESTS_PLAY_WITH_TEAMMATES = (
    <FormattedMessage
        id='clan_landing.clan_supply_quests_play_with_teammates'
        defaultMessage='Зарабатывайте очки похода и промресурс'
    />
)

export const CLAN_SUPPLY_QUESTS_ALL_DONE = (
    <FormattedMessage
        id='clan_landing.clan_supply_all_done'
        defaultMessage='Все задачи выполнены'
    />
)

export const CLAN_SUPPLY_IN_PROGRESS = (
    <FormattedMessage
        id='clan_landing.clan_supply_in_progress'
        defaultMessage='Награда будет начислена в ближайшее время'
    />
)

export const CLAN_SUPPLY_QUESTS_TIME_BEFORE_END = (
    <FormattedMessage
        id='clan_landing.clan_supply_quests_time_before_end'
        defaultMessage='Время до окончания текущего периода'
    />
)

export const CLAN_SUPPLY_QUESTS_TAKE_REWARD = (
    <FormattedMessage
        id='clan_landing.clan_supply_quests_take_reward'
        defaultMessage='Забрать награду'
    />
)

export const CLAN_SUPPLY_PROGRESSION_TITLE = (
    <FormattedMessage
        id='clan_landing.clan_supply_progression_campaign_title'
        defaultMessage='Боевой поход'
    />
)

export const CLAN_SUPPLY_PROGRESSION_PROGRESS_TOOLTIP = (
    <FormattedMessage
        id='clan_landing.clan_supply_progression_campaign_progress_tooltip'
        defaultMessage='Количество открытых регионов'
    />
)

export const CLAN_SUPPLY_PROGRESSION_DISABLED_TEXT = (
    <FormattedMessage
        id='clan_landing.clan_supply_progression_disabled_text'
        defaultMessage='Прогресс боевого похода приостановлен'
    />
)

export const CLAN_SUPPLY_PROGRESSION_REGIONS_EXPLORED = (explored, count, divider) => (
    <FormattedMessage
        id='clan_landing.clan_supply_progression_regions_explored'
        defaultMessage='ОТКРЫТО РЕГИОНОВ:{explored}{divider}{count}'
        values={{ explored, count, divider }}
    />
)

export const CLAN_SUPPLY_SLASH = (
    <FormattedMessage
        id='clan_landing.clan_supply_slash'
        defaultMessage='/'
    />
)

export const CLAN_SUPPLY_PROGRESSION_ALL_REGIONS_EXPLORED = (
    <FormattedMessage
        id='clan_landing.clan_supply_progression_all_regions_explored'
        defaultMessage='БОЕВОЙ ПОХОД ЗАВЕРШЁН'
    />
)

export const CLAN_SUPPLY_PROGRESSION_EXPLORE_NEW_REGIONS = (
    <FormattedMessage
        id='clan_landing.clan_supply_progression_explore_new_regions'
        defaultMessage='Открывайте регионы и получайте награды'
    />
)

export const CLAN_SUPPLY_PROGRESSION_CAN_OPEN_NEW_REGION = (
    <FormattedMessage
        id='clan_landing.clan_supply_progression_can_open_new_region'
        defaultMessage='Вы можете открыть новый регион'
    />
)

export const CLAN_SUPPLY_PROGRESSION_EXPLORE_WITH_NEW_TANK = (
    <FormattedMessage
        id='clan_landing.clan_supply_progression_explore_with_new_tank'
        defaultMessage='Вы можете открыть регион с техникой'
    />
)

export const CLAN_SUPPLY_PROGRESSION_TANK_RECEIVED = (tier, type, name) => (
    <FormattedMessage
        id='clan_landing.clan_supply_progression_tank_received'
        defaultMessage='{tier}{type}{name} получен'
        values={{ tier, type, name }}
    />
)

export const CLAN_SUPPLY_ARC_PROGRESSBAR_STATISTICS = (current, required) => (
    <FormattedMessage
        id='clan_landing.arc_progressbar.statistics'
        defaultMessage='{current}/{required}'
        values={{ current, required }}
    />
)



// WEBPACK FOOTER //
// ./containers/ClanLanding/translations.jsx